import { BaseService, Body, POST, Signal } from 'ts-retrofit3';

import { MESSAGE_API } from '@/Module/Contact/Constant';
import type { IMessage } from '@/Module/Contact/Model/ApiModel/IMessage';
import type { IResponse } from '@/Module/Core/Model/ApiModel';
import { HttpService } from '@/Module/Core/Service';

class MessageService extends BaseService {
  @POST(MESSAGE_API.CREATE_MESSAGE)
  async createMessage(
    @Body _body: Partial<Omit<IMessage, 'id'>>,
    @Signal _signal?: AbortSignal,
  ): Promise<IResponse<IMessage>> {
    return <IResponse>{};
  }
}

export default HttpService.build(MessageService);
